import React from 'react';
import AccreditationBaseTab from './AccreditationBaseTab';

export default function TermsAndAttestationsTab() {
    return <AccreditationBaseTab tabType="manual" />;
}